
import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { UntypedFormBuilder, FormControl, UntypedFormGroup, Validators } from '@angular/forms';
// import { AddCustomerService } from './add-customer.service';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { environment as ENV } from 'environments/environment';

import { Observable } from 'rxjs';
import { CommonFieldsService } from 'app/laas/common-fields.service';
// import { RazPayComponent } from '../raz-pay/raz-pay.component';
import { ViewCustomerService } from '../view-landrecordupdatation/view-customer.service';
import { ApplicantService } from 'app/laas/applicant.service';



@Component({
    selector: 'wl-add-user',
    templateUrl: './add-user.component.html',
    styles: [
        //     `.parent-div {
        //       display: inline-block;
        //       position: relative;
        //       overflow: hidden;
        //     }
        //     .parent-div input[type=file] {
        //       left: 0;
        //       top: 0;
        //       opacity: 0;
        //       position: absolute;
        //       font-size:12px;
        //     }
        //     .btn-upload {
        //       background-color: ##47a339;
        //       border: 0px solid #000;
        //       color: #000;
        //       padding: 10px 25px;
        //       border-radius: 10px;
        //       font-size: 22px;
        //       font-weight: bold;
        //     }
        // s    
        //     `
        `.fileUpload input[type=file]{
      display:none;
    }
    .btn{

      background-color:#47a339;
      color:white;
      border:1px solid #e6e6e6;
      border-radius:3px;
      padding:6px 20px;
      font-size:14px;
    }
    `
    ],
    providers: [CommonFieldsService, ViewCustomerService, ApplicantService]
})
export class AddUserComponent implements OnInit {

    zoneForm: UntypedFormGroup;
    states: any;
    isDataPending: boolean;
    placeholder: String;
    custIds: any;
    isEditable: boolean;
    loanTypes: Observable<any>;
    custType: Observable<any>; plantCode: any;
    plantCodeList: any;
    showMccNplantCode: boolean = false;
    scannedLoanApplication: any;
    bankOrPdcDetails: any;

    appliType: Observable<any>;
    teamMembers: any[];
    groupManagers: any[];
    isManagerSelected: boolean;
    isDataFetchCompleted: boolean;
    role: string;
    isRetail: Observable<any>;
    custTypeValue: any;
    subcategory: Observable<any>;
    selectedCategory: any = {
        id: 0, name: '', value: ''
    };
    custObj: any = {
        catval: "",
        prodval: ""
    };
    mccCodeList: any = [];
    disableSubmitUploadDoc: boolean = false;
    loanFileuploaded: boolean = true;
    @ViewChild('fileInp') fileInp: ElementRef;

    @ViewChild('fileInp2') fileInp2: ElementRef;
    formdata: FormData;
    formdata2: FormData;
    lafile: any;
    colorBlue: boolean;
    colorBlue2: boolean;
    pdcfile: string;
    pdcFileSizeHigh: boolean = false;
    plantCodeNewList: any;
    showMemberCodeNname: boolean = false;
    memberCodeList: any;
    newMccCodeList: any;
    selectedPlantCode: any;
    newMemberCodeList: any;




    constructor(
        private fb: UntypedFormBuilder,

        private updateCust: ViewCustomerService,
        private snackbar: MatSnackBar,
        private dialog: MatDialog,
        private common: CommonFieldsService
    ) {
        this.zoneForm = this.fb.group({
            zone_code: ['', Validators.required],
            zone_name: ['', Validators.required],
            state_name: ['', Validators.required],
        });
        this.placeholder = ENV.placeHolderSetting.placeholder;
    }

    ngOnInit() {
        this.common.getTheState().subscribe(value => {
            console.log(value)
            this.states = value
        })
        this.zoneForm.patchValue({state_name:"Karnataka"})

    }

    stateSelected(event) {

    }


}
